import React, { Fragment, useEffect, useState } from "react";
import {
  convertirFecha,
  capitalizeFirstLetter,
  manejadorDeRespuesta,
  calcularPrecioCharter
} from "../../../../../utils/Tools";
import { Link } from "react-router-dom";
import { chartersAPI } from "../../../../../utils/funcionesAPI";
import Habitaciones from "./habitaciones";
import * as constantes from '../../../../../context/constantes';
import { calcularTotalesHabitaciones } from '../../../../../utils/Tools';
import logoMargarita2 from '../../../../../imagenes/logoMargarita2.png'

const CharterFila = (props) => {
  const [puntosDeEmbarques, setPuntosDeEmbarques] = useState([]);

  const { 
    charter = {}, 
    producto, 
    idCharterSeleccionado, 
    idCharterDeURL, 
    origen, 
    onChangeHabitacionesElegidas,
    pasajerosAdultos,
    tarifaPorHabitacion
  } = props;

  const { habitacionesElegidas: habitacionesElegidasPorDefecto } = charter;

  const [habitacionesElegidas, setHabitacionesElegidas] = useState(habitacionesElegidasPorDefecto);
  const [totalesDeHabitaciones, setTotalesDeHabitaciones] = useState(charter.totalesDeHabitaciones || {});

  useEffect(() => {
    if (idCharterDeURL) {
      handleCharterRadioClick({
        target: { value: idCharterDeURL },
      });
    }
     
  }, []);

  useEffect(() => {
    setHabitacionesElegidas(habitacionesElegidasPorDefecto);
    setTotalesDeHabitaciones(charter.totalesDeHabitaciones);
     
  }, [charter]);

  const handlePuntoDeEmbarqueClick = (e) => {
    e.preventDefault();

    const data = JSON.stringify({
      peticion: "traerPuntosDeEmbarque",
      idCharter: charter.idCharter,
      origen: origen,
    });
    chartersAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(this.props, respuesta)) {
        setPuntosDeEmbarques(respuesta);
      }
    });
  };

  const handleCharterRadioClick = (e) => {
    props.onCharterClick(Number(e.target.value));
  };

  const handleComprarCharterClick = (e) => {
    props.onComprarCharterClick(Number(e.target.name), habitacionesElegidas, e);
  };

  const handleHabitacionesElegidasChange = (action) => {
    const habitacionesMod =  JSON.parse(JSON.stringify(habitacionesElegidas));

    if (action.type === constantes.ADD_HABITACION) {
      habitacionesMod.push(action.payload);
    }

    if (action.type === constantes.REMOVE_HABITACION) {
      habitacionesMod.pop();
    }
    
    setHabitacionesElegidas(habitacionesMod);
    onChangeHabitacionesElegidas(charter, habitacionesMod);

    if (habitacionesMod.length === 0) {
        setTotalesDeHabitaciones(
          {
            "total": 0,
            "totalPorPersona": 0,
            "totalTasasEimpuestos": 0,
            "totalPorPersonaConValijaYa": 0,
            "totalPorPersonaConValijaYaNeto": 0,
            "totalPorPersonaNeto": 0,
            "textoBase": ""
          }
        )
      } else {
        calcularTotalesHabitaciones(charter.idCharter, habitacionesMod, origen, setTotalesDeHabitaciones);
      }
  }

  const hayLugarDisponible = (pasajerosAdultos = [], charter = {}) => {
    if (pasajerosAdultos.length <= (charter.plazas - charter.plazasOcupadas)) 
      return true;
    return false;
  }

//FC: descomentar cuando se vuelva a mostrar pesos
  /*
  const precioCharter = Math.round(
    (charter.tarifa.tarifaNeta -
      charter.tarifa.tarifaNeta * (charter.promoValijaYa / 100) +
      charter.tarifa.adicionalPorDia) *
      producto.moneda.cotizacion
  ).toLocaleString();
  */
  const precioCharter = calcularPrecioCharter(charter);
  let iconoPuntoEmbarque = "departure_board";
  if (producto.transporte.descripcion === "AER")
    iconoPuntoEmbarque = "flight_takeoff";

  return (
    <Fragment>
    <li className="row">
      <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12">
      {!tarifaPorHabitacion ? (
        <div className="md-radio">
        
          <input
            type="radio"
            id={charter.idCharter}
            name={producto.idProducto}
            onChange={handleCharterRadioClick}
            value={charter.idCharter}
            checked={idCharterSeleccionado === charter.idCharter}
          />
        <label className="labelCharter" htmlFor={charter.idCharter}>
            {capitalizeFirstLetter(convertirFecha(charter.fechaSalida))}{" "}
          </label>
         
        </div>
         ) : (
          <label className="labelCharter" htmlFor={charter.idCharter}>
          {capitalizeFirstLetter(convertirFecha(charter.fechaSalida))}{" "}
        </label>
         )}
        {tarifaPorHabitacion && hayLugarDisponible(pasajerosAdultos, charter) && (
          <div className="row">
            <Habitaciones
              habitaciones={habitacionesElegidas}
              dispatch={handleHabitacionesElegidasChange}
              tiposDeHabitacion={charter.habitaciones}
              pasajerosAdultos={pasajerosAdultos}
            /> 
          </div>
        )}
      </div>
      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
        <div className="online">
          <i className="material-icons">check</i>
          <p>Disponible</p>
        </div>
        {charter.promoValijaYa > 0 && (
          <div className="descuento">
            <p>{Number(charter.promoValijaYa)} % OFF</p>
          </div>
        )}
        {
          charter.incluyeMargarita && (
            <div className='contenedorIncluyeMarga'>
            <div className="incluyeMargarita">
              <div>Tu paquete <span style={{'fontWeight': 'bold'}}>incluye</span></div>
              <div>un <span style={{'fontWeight': 'bold'}}>dia de campo</span> en</div>
              <div style={{'fontWeight': 'bold'}}>ESTANCIA LA MARGARITA
              <br />
              <span style={{fontSize: '18px'}}>¡Sin Cargo!</span>
              {/*<img src={logoMargarita2} width="40" alt='Logo Estancia Margarita' />*/}
              </div>
            </div>
            </div>
          )
        }
        {charter.plazas - charter.plazasOcupadas <= 5 && (
          <div className="ultimosLugares">
            Ultimos {charter.plazas - charter.plazasOcupadas} Lugares
          </div>
        )}


       
      </div>
      <div className="col-xl-5 col-lg-5 col-md-4 col-sm-12 col-12">
        <div
          className="dropdown cuadroPuntosEmbarques"
          data-toggle="dropdown"
          aria-expanded="false"
        >

          {producto.transporte && producto.transporte.descripcion !== "" && (
            <p className="embarqueResultados" onClick={handlePuntoDeEmbarqueClick}>
              <i
                className="material-icons alineacionIconoContenido iconoPuntoEmbarque dropdown-toggle"
                title="Ver Puntos de Embarque"
              >
                {iconoPuntoEmbarque}
              </i> <span>Ver Embarques</span>
            </p>
          )}
          <div
            className="dropdown-menu cuadroHorarios text-left"
            aria-labelledby="dropdownMenuButton"
          >
            <p className="tituloCuadroPuntoDeEmbarque">Puntos de Embarque:</p>
            <ul className="listaCuadroPuntoDeEmbarque">
              {puntosDeEmbarques.length > 0 ? (
                puntosDeEmbarques.map((puntoDeEmbarque) => {
                  return (
                    <li key={puntoDeEmbarque.idPuntoDeEmbarque}>
                      {puntoDeEmbarque.denominacion}
                    </li>
                  );
                })
              ) : (
                <li>A definir</li>
              )}
            </ul>
          </div>
        </div>
        { 
        hayLugarDisponible(pasajerosAdultos, charter) && (
          <Link
          to="/paquete-turistico/proceso-compra/login/"
          name={charter.idCharter}
          onClick={handleComprarCharterClick}
        >
          comprar
        </Link>
        )}
        
        <p>
          {producto.moneda.simbolo} {tarifaPorHabitacion ? (Math.trunc(totalesDeHabitaciones.totalPorPersonaConValijaYaNeto)).toLocaleString() : precioCharter} <span> + tasas e impuestos</span>
        </p>
      </div>
      
    </li>
   
    </Fragment>
  );
};

export default CharterFila;



// WEBPACK FOOTER //
// ./src/components/Resultados/ListadoProducto/ProductoCuadro/CharterFila/index.js